import type { ModelState } from "@/types/model";
import { useTeamEditionStore } from "@/store/teamEdition";
import { getEventTrackSource } from "@/assets/sensors/event_track_source";
import { _postRequest } from "./request-util";

/* 
  start: 启动事件
  enter: 曝光事件
  click: 点击事件
  create_event: 提交生图事件
  artwork_status_event: 生图结果展示事件
  save_img: 图片右键保存事件
*/

export interface DirectiveBindingValue {
  event: string;
  eventValue: Record<string, string | number | boolean | any[]>;
  imageAction?: boolean;
  uniqueId: string;
  headers: {
    Token: string;
  };
}

export async function handleMessage(data: any) {
  let { event: eventName, eventValue, imageAction, uniqueId, headers } = data;

  // 图片操作
  if (imageAction && eventValue.imageId) {
    let data = await _postRequest("/api/artwork/imgDetail", { data: { id: eventValue.imageId as number }, headers });

    if (data && data.param) {
      const modelList: ModelState[] = data.param?.modelList || [];
      const model_id = modelList.map((item) => item.id).join(",");
      const model_name = modelList.map((item) => item.modelName).join(",");
      const lora_type = modelList.map((item) => item.loraType).join(",");
      const ckpt_type = modelList.map((item) => item.ckptType).join(",");

      eventValue = {
        ...eventValue,
        artwork_name: data.artworkName || "",
        artwork_version: data.versionId || "",
        model_id,
        model_name,
        lora_type,
        ckpt_type
      };

      delete eventValue.imageId;
    }
  }

  // version	团队版 or 个人版	字符串	标识用户当前上报行为是在 团队版还是个人版，跟随事件上报
  eventValue.version = useTeamEditionStore().userType === "team" ? "团队版" : "个人版";

  _postRequest("/api/common/burial", {
    data: { eventName: eventName, map: eventValue, uniqueId },
    headers
  });
}

export async function handleMessageBeforeLogin(data: any, headers: Record<string, string> = {}) {
  const eventName = data.event;
  const eventValue = data.eventValue;
  const uniqueId = data.uniqueId;
  const source = await getEventTrackSource();
  eventValue.source = source;
  _postRequest("/external/burial", {
    data: { eventName: eventName, map: eventValue, uniqueId },
    headers
  });
}
